import React, { PropTypes } from 'react';

const propTypes = {
  day: PropTypes.number.isRequired,
  activeDay: PropTypes.number.isRequired,
  children: PropTypes.node,
  onDateChange: PropTypes.func.isRequired,
};

const Item = ({ day, activeDay, children, onDateChange }) => {
  const handleClick = () => {
    onDateChange(day);
  };

  const className = day === activeDay
  ? 'active item'
  : 'item';

  return <a onClick={handleClick} className={className}>{children}</a>;
};

Item.propTypes = propTypes;

export default Item;



/** WEBPACK FOOTER **
 ** ./src/components/layout/nav/dates/Item.js
 **/